
export const Inputs = [
    [
        {
            type: "email",
            name: "email",
            title: { ar: "", en: "" },
            label: { ar: "", en: "" },
            placeholder: { ar: "البريد الالكتروني", en: "Email" },
            size: { lg: "6", md: "6" }
            
        },
        {
            type: "text",
            label: { ar: "", en: "" },
            placeholder: { ar: "ادخل الرمز", en: "Enter code" },
            title: { ar: "", en: "" },
            name: "caption",
            size: { lg: "6", md: "6" },
            class: "largeScreen"
        },
        {
            type: "password",
            label: { ar: "", en: "" },
            placeholder: { ar: "**********", en: "**********" },
            title: { ar: "", en: "" },
            name: "password",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            label: { ar: "", en: "" },
            placeholder: { ar: "ادخل الرمز", en: "Enter code" },
            title: { ar: "", en: "" },
            name: "caption",
            size: { lg: "6", md: "6" },
            class: "smallScreen"
        },
    ]

];

